// extracted by mini-css-extract-plugin
export default {"animal-box":"Livestock_animal-box__TFrcs","animal-profile-pic":"Livestock_animal-profile-pic__IfGtI"};